import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 datasources",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DataSources.deleteConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: _vm.color,
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.deleteItem
    }
  }), _c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id",
      "page": _vm.tableOptions.page
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination],
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', {
          staticClass: "clickable"
        }, [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "70px"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v("\n          " + _vm._s(items.item.id) + "\n        ")]), _c('td', {
          staticStyle: {
            "width": "34px"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [items.item.image ? _c('img', {
          staticClass: "icon",
          attrs: {
            "src": _vm.niota1ImageUrl(items.item.image)
          }
        }) : _vm._e()]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v(_vm._s(items.item.source))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v(_vm._s(items.item.type))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v(_vm._s(items.item.status))]), _c('td', {
          staticClass: "text-center",
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(items.item.active ? 'check' : 'times '))])], 1), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v(_vm._s(_vm.localizeDate(items.item.createdAt)))]), _c('td', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.permissions['super.system.manage'] ? _vm.$i18n_t('Common.edit') : _vm.$i18n_t('Common.viewDetails'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v("\n            fal fa-" + _vm._s(_vm.permissions['super.system.manage'] ? 'edit' : 'eye') + "\n          ")]), _vm._v("\n           \n          "), _vm.permissions['super.system.manage'] ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.showDeletePrompt(items.item);
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")]) : _vm._e()], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };